import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=eed55cb2&scoped=true&"
import script from "./page2.vue?vue&type=script&lang=js&"
export * from "./page2.vue?vue&type=script&lang=js&"
import style0 from "./page2.vue?vue&type=style&index=0&id=eed55cb2&lang=less&scoped=true&"
import style1 from "./page2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed55cb2",
  null
  
)

export default component.exports